import * as React from "react";
import {Link} from "@reach/router";

class AppTest extends React.Component{
    render(){
    return <>
        <Link to='hello'>Hello</Link>
        <Link to='/hello'>Hello2</Link>
        <Link to='../hello'>Hello3</Link>
        </>;
    }
}

export default AppTest;